import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## Welcome to the OnBoard developer portal

One place to find the services, APIs, docs and owners behind OnBoard.

- **Browse the catalog** to see what exists and who owns it in the
  [Software Catalog](/catalog)
- **Scaffold something new** from a [Software Template](/create)
- **Read the docs** from any entity's Docs tab, or search them all from the
  bar above
- **Star what you use** and it shows up on this page

Missing or wrong? Every entity has a \`catalog-info.yaml\` in its repo; fix it
there and the catalog picks it up automatically.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Getting Started',
    description: 'Orientation and links for the OnBoard developer portal',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
